module.exports = __webpack_public_path__ + "zaincash.svg?271e2a809f7156c06af2a29c7a8b3c2d";


//////////////////
// WEBPACK FOOTER
// ./assets/images/zaincash.svg
// module id = 296
// module chunks = 0